import React, { useEffect } from "react";

const Redirect = () => {
  const newUrl = "https://degreeclassify.co.uk/";

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = newUrl;
    }, 4000); // redirect after 4 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Site Has Moved</h1>

        <p style={styles.text}>
          This website has migrated to a new address.
        </p>

        <p style={styles.text}>
          You will be automatically redirected shortly.
        </p>

        <a href={newUrl} style={styles.button}>
          Go to the new website
        </a>

        <p style={styles.small}>
          New URL: <strong>https://degreeclassify.co.uk/</strong>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f7fa",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif"
  },
  card: {
    background: "white",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "500px"
  },
  title: {
    marginBottom: "20px",
    fontSize: "28px"
  },
  text: {
    marginBottom: "10px",
    fontSize: "16px"
  },
  button: {
    display: "inline-block",
    marginTop: "20px",
    padding: "12px 24px",
    backgroundColor: "#2563eb",
    color: "white",
    textDecoration: "none",
    borderRadius: "6px",
    fontWeight: "600"
  },
  small: {
    marginTop: "20px",
    fontSize: "14px",
    color: "#666"
  }
};

export default Redirect;